import { render } from "./WpeRadio.vue?vue&type=template&id=0bde8a28"
import script from "./WpeRadio.vue?vue&type=script&lang=js"
export * from "./WpeRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/controls/WpeRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bde8a28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bde8a28', __exports__)) {
    api.reload('0bde8a28', __exports__)
  }
  
  module.hot.accept("./WpeRadio.vue?vue&type=template&id=0bde8a28", () => {
    api.rerender('0bde8a28', render)
  })

}


export default __exports__